const KEYS = {
  MIXPANEL_TOKEN : "b8f73572deb207a7694abda3e44219a7"
    
    };
    
export default KEYS;